/**
 * Project JS controller.
 */

// Use jQuery as $ within this file scope.
const $ = jQuery;

/**
 * Class Project
 */
class Project {

    /**
     * Cache dom elements for use in the class's methods
     */
    cache() {
        this.titleAndBreadcrumb = $( '#title-and-breadcrumbs' );
        this.mobileLocation = $( '#mobile-header' );
        this.wideLocation = $( '#wide-header' );
    }

    /**
     * All common events
     * @return {void}
     */
    events() {

        // Set the steps wrap minus margin while resizing
        $( window ).on( 'resize', ( e ) => {
            this.moveTitle();
        });

    }

    /**
     * Move title and breadcrumbs from content section into another location.
     * Title and breadcrumbs will be shown on mobile all the time instead of inside a tab.
     */
    moveTitle() {

        // Move title and breadcrumbs into another location
        // when the window width is small enough.
        if ( $( window ).width() <= 1024 ) {

            if ( this.mobileLocation.html().length <= 10 ) {
                document.getElementById( 'mobile-header' ).appendChild(
                    document.getElementById( 'title-and-breadcrumb' )
                );
            }

        } else {

            if ( this.wideLocation.html().length <= 10 ) {
                document.getElementById( 'wide-header' ).appendChild(
                    document.getElementById( 'title-and-breadcrumb' )
                );
            }

        }
    }

    /**
     * Run when the document is ready.
     */
    docReady() {
        this.cache();
        this.events();
        this.moveTitle();
    }
}

// Export the class reference.
module.exports = Project;



// WEBPACK FOOTER //
// ../vaasa/assets/scripts/project.js